<template>
    <div class="col-sm-12 col-md-6 col-lg-4">
        <card>
                 <span slot="header">
                    Queue - {{ queue.name }}
                  </span>
            <base-input
                :value="queue.name"
                label="Name"
                required
                :ref="'input' + queue"
                :name="'name-' + queue"
                v-validate="'required|min:3|max:50'"
                @input="handleNameInputChange"
                :error="getError('name-' + queue)"
            ></base-input>
            <hr>
            <music-on-hold-selector @change="dirty = true" v-model="queue.musiconhold"></music-on-hold-selector>
            <hr>
            <div>
                <div>
                    <label>Timeout</label>
                </div>
                <el-input-number v-model="queue.timeout" :min="1" size="small"
                                 :max="300"></el-input-number>
                <small id="timeoutHelp" class="form-text text-muted">
                    Each ring is about 4 seconds. {{ queue.timeout }} seconds is about {{
                    timeoutRings }} rings.
                </small>
            </div>
            <hr>
            <div>
                <base-input label="Strategy" required="">
                    <select
                        v-model="queue.strategy"
                        @change="dirty = true"
                        class="form-control"
                        size="small"
                        required
                        name="strategy">
                        <option class="select-primary"
                                label="Ring all"
                                value="ringall">
                        </option>
                        <option class="select-primary"
                                label="Round Robin"
                                value="roundrobin">
                        </option>
                        <option class="select-primary"
                                label="Round Robin Memory"
                                value="rrmememory">
                        </option>
                        <option class="select-primary"
                                label="Least Recent"
                                value="leastrecent">
                        </option>
                        <option class="select-primary"
                                label="Fewest Calls"
                                value="fewestcalls">
                        </option>
                        <option
                            class="select-primary"
                            label="Random"
                            value="random">
                        </option>
                    </select>
                </base-input>
                <small id="strategyHelp" class="form-text text-muted">
                    <span v-if="queue.strategy === 'ringall'">The "Ring all" strategy will ring all destinations at the same time until the timeout is reached.</span>
                    <span v-if="queue.strategy === 'random'">The "Random" strategy will pick a random destination and will only ring that destination until the timeout is reached.</span>
                    <span v-if="queue.strategy === 'roundrobin'">The "Round Robin" strategy will take turns ringing each available destination</span>
                    <span v-if="queue.strategy === 'rrmemory'">The "Round Robin Memory" strategy will take turns ringing each available destination and remember its position with each call.</span>
                    <span v-if="queue.strategy === 'leastrecent'">The "Least Recent" strategy will call the destination least recently called by this queue.</span>
                    <span v-if="queue.strategy === 'fewestcalls'">The "Fewest Calls" strategy will call the destination with the fewest completed calls.</span>
                </small>
            </div>
            <hr>
            <device-number-selector :devices="queue.devices" :numbers="queue.numbers"
                                    v-on:number-add="handleDestinationNumberAdd()"
                                    v-on:number-remove="handleDestinationNumberRemove($event)"
                                    v-on:number-update="handleDestinationNumberUpdate($event)"
                                    v-on:device-add="handleDeviceAdd($event)"
                                    v-on:device-remove="handleDeviceRemove( $event)"/>
            <div slot="footer">
                <div class="row">
                    <div class="col">
                        <base-button class="left" :loading="saving" :disabled="!dirty"
                                     @click="save" type="primary">
                            Save
                        </base-button>

                        <base-button icon @click="remove" type="danger" :loading="removing"
                                     class="right">
                            <font-awesome-icon v-if="!removing" :icon="['fal','trash']"></font-awesome-icon>
                        </base-button>

                    </div>
                </div>

            </div>
        </card>
    </div>
</template>
<script>
    import DeviceNumberSelector from "../Ringgroup/DeviceNumberSelector"
    import swal from 'sweetalert2';
    import MusicOnHoldSelector from "../../components/MusicOnHold/MusicOnHoldSelector";

    export default {
        name: 'QueueCard',
        components: {MusicOnHoldSelector, DeviceNumberSelector},
        props: {
            initialQueue: {}
        },
        computed: {
            timeoutRings() {
                return Math.floor(this.queue.timeout / 4);
            }
        },
        data() {
            return {
                dirty: false,
                removing: false,
                saving: false,
                queue: null,
                origName: '',
            }
        },
        created() {
            this.queue = JSON.parse(JSON.stringify(this.initialQueue));
            this.origName = this.queue.name;
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            handleNameInputChange(value) {
                this.queue.name = value.replace(/[#,."'/\\`~ :;}{|$&%^?+*]/g, '');
                this.dirty = true;
                this.$emit('dirty', this.dirty);
            },
            save() {
                this.saving = true;
                let data = this.queue;
                let name = this.queue.id;
                this.$store.dispatch('queue/save', {name, data}).then(() => {
                    this.$notify({
                        verticalAlign: 'bottom',
                        horizontalAlign: 'right',
                        message: 'Your queue: ' + data.name + ' was saved!',
                        type: "success",
                        icon: "fal fa-save",
                        title: "Saved!"
                    });

                    this.dirty = false;
                    this.saving = false;
                    this.$emit('saved');

                }).catch(() => {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Your queue: ' + data.name + ' failed to save!',
                        type: "error",
                        icon: "fal fa-times",
                        title: "Error!"
                    });

                    this.saving = false;
                });
            },
            remove() {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to restore this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.removing = true;
                        let name = this.queue.name;
                        this.$store.dispatch('queue/remove', {name}).then(() => {
                            this.$notify({
                                verticalAlign: 'bottom',
                                horizontalAlign: 'right',
                                message: 'Your queue: ' + name + ' was removed!',
                                type: "success",
                                icon: "fal fa-trash",
                                title: "Removed!"
                            });

                            this.dirty = false;
                            this.saving = false;
                            this.removing = false;
                            this.$emit('removed');
                        })
                    }
                });
            },
            handleDestinationNumberAdd() {
                this.queue.numbers.push('+99');
                this.dirty = true;
                this.$emit('dirty', this.dirty);
            },
            handleDestinationNumberUpdate(event) {
                let number = event.number;
                let nIndex = event.nIndex;
                this.queue.numbers[nIndex] = number;
                this.dirty = true;
                this.$emit('dirty', this.dirty);
            },
            handleDestinationNumberRemove(event) {
                let number = event.number;
                this.queue.numbers = this.queue.numbers.filter(d => d !== number);
                this.dirty = true;
                this.$emit('dirty', this.dirty);
            },
            handleDeviceAdd(event) {
                let device = event.device;
                this.queue.devices.push(device);
                this.dirty = true;
                this.$emit('dirty', this.dirty);
            },
            handleDeviceRemove(event) {
                let name = event.name;
                this.queue.devices = this.queue.devices.filter(d => d.name !== name);
                this.dirty = true;
                this.$emit('dirty', this.dirty);
            }
        },
    }
</script>
